<section id="contact">
    <div class="contact_info">
        <div class="container contact_info_inner">
            <h5><a routerLink="contact">get in touch</a></h5>
            <h2 class="details_font">
                If you have any questions or concerns, a member of staff will always be pleased to assist you.
                 To contact us, please call any of the numbers mentioned below or send an email,
                  and we will respond as soon as possible.
            </h2>
        </div>
        <div class="contact_social">
            <span class="details_font"><i class="fa fa-facebook-square"></i><a href="https://www.facebook.com/OmSaiEnterprises.786" title="OmSaiEnterprises.786" target="_blank">facebook</a></span>
            <span class="details_font"><i class="fa fa-instagram"></i><a href="https://www.instagram.com/omsaienterprises786" title="omsaienterprises786" target="_blank">instagram</a></span>
        </div>
    </div>
    <div class="contact_inner container">
        <div>
            <div class="contact_grid">
                <div class="contact_grid_data">
                    <h2>reach us at</h2>
                    <h4>omsaienterprises7861@gmail.com</h4>
                    <h4>+91 9867160295</h4>
                    <h4>+91 9821438731</h4>
                    <div class="contact_grid_btn">
                        <a href="https://bit.ly/3daQjdT" target="_blank">
                            <div class="contact_btn">send a message</div>
                        </a>
                        <a href="tel:919867160295">
                            <div class="contact_btn call_btn">give a call</div>
                        </a>
                    </div>
                </div>
                <div class="contact_grid_data">
                    <h2>our location</h2>
                    <h4>Kothari Warehouse, P-9, / B1, (27 Acre),<br/>
                        Tikuji Ni Wadi Road, Manpada, <br>
                        Thane West - 400610
                    </h4>
                    <a href="https://goo.gl/maps/qjM2u2VdjdKwEvhs8" target="_blank">
                        <div class="contact_btn">get directions</div>
                    </a>
                </div>
                
            </div>
        </div>
    </div>
</section>